import { Header } from "antd/es/layout/layout";
import { rgba } from "config/variable";
import styled from "styled-components";

export const HeaderStyle = styled(Header)`
  &.ant-layout-header {
    background: ${(props) => props.theme.colordwhitedark};
    padding: 17px 25px 16px 17px;
    height: 64px;
    display: flex;
    gap: 15px;
    padding-inline: 16px;
    box-shadow: 0px 2px 6px ${(props) => rgba(props.theme.colortileblack, 0.08)};
    line-height: 1;
    border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
  }
`;
export const LogoStyle = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    img{
        width: 170px;
        max-width: 100%;
    }
`;
export const NavBar = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;
export const NavLeft = styled.div``;
export const NavCenter = styled.div`
  width: 320px;
  .ant-form-item {
    margin: 0;
    .ant-input-prefix {
      border-right: 1px solid ${(props) => props.theme.colorbluegreylight};
      border-radius: 2px;
      padding-right: 12px;
    }
    .ant-input {
      padding-left: 12px;
    }
  }
`;
export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  .buttonwrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    .ant-btn {
      min-width: unset;
      padding: 0;
    }
  }
  .userprofile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    max-height: 40px;
    .username {
      font-weight: 700;
      font-size: 12px;
      line-height: 18px;
      @media (min-width: 0px) and (max-width: 360px) {
        font-size: 11px;
      }
    }
    .useremail {
      @media (min-width: 0px) and (max-width: 360px) {
        font-size: 11px;
      }
    }
    .drop-icon {
      color: ${(props) => props.theme.textcolordarkgrey};
    }
  }
`;
